import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type User = {
  id: string;
  email: string;
  username: string;
  created_at: string;
};

export type Token = {
  id: string;
  name: string;
  symbol: string;
  creator_id: string;
  total_supply: number;
  current_price: number;
  is_approved: boolean;
  created_at: string;
};

export type TokenTransaction = {
  id: string;
  token_id: string;
  buyer_id: string;
  seller_id: string;
  amount: number;
  price: number;
  created_at: string;
}; 